import { useAtomValue } from 'jotai/react';
import { useEffect } from 'react';

import { useProvider } from '@/hooks/use-provider';
import { subscribe } from '@/lib/desktop-sse';
import { authenticatedAtom } from '@/lib/store';
import { PROVIDERS } from '@/providers';

export const useScreenPopToCaseSSE = () => {
  const [provider] = useProvider();
  const isAuthenticated = useAtomValue(authenticatedAtom);

  useEffect(() => {
    if (!isAuthenticated || provider.id !== PROVIDERS.SALESFORCE) return;

    return subscribe('screen-pop-to-case', (ev: MessageEvent) => {
      try {
        const payload = JSON.parse(ev.data);
        provider.openCase(payload.caseId);
      } catch (e) {
        console.warn('[DesktopSSE] Failed parsing screen-pop-to-case event', e);
      }
    });
  }, [provider, isAuthenticated]);
};
